/**
 * Derives the id of an inner control from its parent's id (e.g. `objectives-file-form-field` → `objectives-file-form-field-upload`),
 * so e2e tests can target the element actually clicked inside shared components.
 * Returns `undefined` when the parent has no id, instead of rendering `undefined-upload`.
 */
export const suffixId = (id: string | undefined, suffix: string): string | undefined =>
  id ? `${id}-${suffix}` : undefined;
